import React from 'react'
import { graphql } from 'relay-runtime'
import styled from '@emotion/styled'
import { useFragment } from 'react-relay'
import { CommentList$key } from './__generated__/CommentList.graphql'
import { CommentContainer } from './Comment'

interface CommentListProps {
  fragmentRequest: CommentList$key | null
}

export const commentListFragment = graphql`
  fragment CommentList on MetaAd {
    comments {
      id
      ...Comment
    }
  }
`

const S = {
  Wrapper: styled.div`
    & > * {
      margin-bottom: 2rem;
    }
  `,
}

const CommentList = ({ fragmentRequest }: CommentListProps) => {
  const metaAd = useFragment(commentListFragment, fragmentRequest)
  return (
    <S.Wrapper>
      {metaAd!.comments.map((it) => (
        <CommentContainer key={it.id} fragmentRequest={it} />
      ))}
    </S.Wrapper>
  )
}

export default CommentList
